import React from 'react';
import {
	Tooth,
	ToothPresence,
	ToothRestorationCrownType,
	ToothState,
} from '../../../../graphql/graphql';
import { apicalDefinition } from './apicalDefinition.const';
import { ToothView } from '../../Enums/ToothView.enum';

interface Props {
	tooth: Tooth;
	view: ToothView;
	width: number;
	height: number;
}

const DENTToothApical = ({ tooth, view, width, height }: Props) => {
	const showApical =
		tooth.state !== ToothState.Implant &&
		tooth.restoration?.crownType !== ToothRestorationCrownType.Pontic &&
		tooth.pathology?.apical?.values.presence === ToothPresence.Yes;

	if (!(showApical && tooth.number)) {
		return null;
	}

	const apicalDefinitions = apicalDefinition[tooth.number][view];

	if (!apicalDefinitions) {
		return null;
	}

	return (
		<>
			{apicalDefinitions.map(({ centerX, centerY }, index) => (
				<svg
					key={`apical-${index}`}
					width={width}
					height={height}
					viewBox={`0 0 ${width} ${height}`}>
					<circle
						cx={centerX}
						cy={centerY}
						r={13}
						stroke='red'
						strokeWidth={1}
						fill='none'
					/>
				</svg>
			))}
		</>
	);
};

export default DENTToothApical;
